import type { Playbook } from "../types/playbooks.types";

export type SplitPlaybooksResult = {
    sharedRows: Playbook[];
    privateRows: Playbook[];
};

const matchesSearch = (playbook: Playbook, search: string): boolean => {
    if (!search) {
        return true;
    }

    const values: string[] = [playbook.name ?? "", playbook.description ?? "", playbook.cadence?.name ?? ""];
    return values.some((value) => value.toLowerCase().includes(search));
};

export const countPlaybooksBySegment = (playbooks: readonly Playbook[]) => {
    let sharedCount = 0;
    for (const playbook of playbooks) {
        if (playbook.isSharedWithAccount) {
            sharedCount++;
        }
    }
    return { sharedCount, privateCount: playbooks.length - sharedCount };
};

export const splitPlaybooks = (playbooks: readonly Playbook[], searchTerm: string): SplitPlaybooksResult => {
    const trimmedSearch = searchTerm.trim().toLowerCase();
    const sharedRows: Playbook[] = [];
    const privateRows: Playbook[] = [];

    playbooks.forEach((playbook) => {
        if (!matchesSearch(playbook, trimmedSearch)) {
            return;
        }
        (playbook.isSharedWithAccount ? sharedRows : privateRows).push(playbook);
    });

    return { sharedRows, privateRows };
};
